import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type WorkforceNotificationsEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const workforceNotificationsEntryPoint: EntryPoint<
	WorkforceNotificationsEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<WorkforceNotificationsEntryPointComponent>(
		/* webpackChunkName: "async-personal-settings-workforce-notifications" */ './WorkforceNotifications.tsx',
	),
	getPreloadProps: () => ({}),
});
